const handleObjectItemHover = () => {
  const objectItemClass = 'objects-new-item';
  const objectItemTextClass = 'objects-new-item-text';

  $(`.${objectItemClass}`).hover(function () {
    $(this).find(`.${objectItemTextClass}`).stop(true, false).fadeToggle(400);
  });
};

const ObjectsComponent = () => {
  handleObjectItemHover();
};

export const Objects = () => {
  $(document).ready(() => ObjectsComponent());
};
